module.exports = __webpack_public_path__ + "static/media/welcome-end.85f31fc6.svg";